import React from 'react';
import cx from 'classnames';
import _get from 'lodash/get';
import pickUpPin from 'public/images/pick-up-with-shadow.svg';
import styles from './set-up-deliveries.less';

const PickUpKeys = ({
  pickUps,
  currentPickUpKey,
  deliveries,
  onSelectPickUpKey,
}) => {
  if (!pickUps || pickUps.length < 1) {
    return null;
  }
  return pickUps.map(key => {
    const pickUpKey = key.pickUpKey;
    const delivery = deliveries.find(
      delivery => delivery.id === key.deliveryIDs[0],
    );
    const pickUp = _get(delivery, ['detail', 'pickUp'], null);
    if (!pickUp) return null;
    return (
      <div
        key={pickUpKey}
        onClick={onSelectPickUpKey(pickUpKey)}
        className={cx(styles.pickUpAddress, {
          [styles.selected]: pickUpKey === currentPickUpKey,
        })}
      >
        <img alt="" src={pickUpPin} className={styles.icon} />
        <div className={styles.pickUpInfo}>
          <div className={styles.firstLine}>{_get(pickUp, 'name')}</div>
          <div className={styles.secondLine}>
            {`${_get(pickUp, 'phone')} • ${_get(pickUp, 'poi.address.name')}`}
          </div>
        </div>
      </div>
    );
  });
};

export default PickUpKeys;
